import React, { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@material-ui/core';
import { GridCloseIcon } from '@mui/x-data-grid';
import { useAppContext } from 'core/contexts';
import styles from './SGSModal.module.scss';

interface ModalProps {
    isOpenModal: boolean;
    setIsOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    title: string;
    titleIcon?: any;
    actionToolbar?: () => ReactNode;
    children: ReactNode;
    modalWidth?: string; // Property for setting modal width
    centerTitle?: boolean; // Property for centering the title
    centerContent?: boolean; // Property for centering the content
}

const SGSModalBlue: FC<ModalProps> = ({ isOpenModal, setIsOpenModal, title, titleIcon = null, children, actionToolbar = null, modalWidth = '100%', centerTitle = false, centerContent = false }) => {
    const { user } = useAppContext();

    const handleClose = (): void => {
        setIsOpenModal(false);
    };

    function BootstrapDialogTitle(props: any) {
        const { children, onClose, ...other } = props;

        return (
            <DialogTitle sx={{ m: 0, p: 2 }} {...other} style={{ textAlign: centerTitle ? 'center' : 'left' }}>
                {children}
                {onClose && (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        style={{
                            position: 'absolute',
                            width: 40,
                            height: 40,
                            right: 30,
                            top: 30,
                        }}
                    >
                        <GridCloseIcon
                            style={{
                                position: 'absolute',
                                right: 0,
                                top: 0,
                                width: 40,
                                height: 40,
                                color: '#fff',
                            }}
                        />
                    </IconButton>
                )}
            </DialogTitle>
        );
    }

    return (
        <Dialog
            open={isOpenModal && Boolean(user?.token)}
            onClose={handleClose}
            maxWidth="md"
            PaperProps={{
                style: { width: modalWidth, maxHeight: '80vh', borderRadius: 10 },
            }}
        >
            <BootstrapDialogTitle onClose={handleClose} className={styles.header}>
                <Box display="flex" alignItems="center" justifyContent={centerTitle ? 'center' : 'space-between'}>
                    <Box display="flex" alignItems="center" justifyContent={centerTitle ? 'center' : 'flex-start'} width="100%">
                        {titleIcon && !centerTitle && <img src={titleIcon} alt="titleIcon" className={styles.errorIcon} width={44} />}
                        <span className={styles.header__text}>{title}</span>
                    </Box>
                </Box>
            </BootstrapDialogTitle>
            <DialogContent>
                <DialogContentText className={styles.modalContent} style={{ textAlign: centerContent ? 'center' : 'left' }}>
                    {children}
                </DialogContentText>
            </DialogContent>
            <DialogActions className="mb-4" style={{ paddingRight: 70 }}>
                {actionToolbar && actionToolbar()}
            </DialogActions>
        </Dialog>
    );
};

SGSModalBlue.propTypes = {
    isOpenModal: PropTypes.bool.isRequired,
    setIsOpenModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    actionToolbar: PropTypes.func,
    children: PropTypes.node.isRequired,
    modalWidth: PropTypes.string,
    centerTitle: PropTypes.bool, // New prop type for centering the title
    centerContent: PropTypes.bool, // New prop type for centering the content
};

export default SGSModalBlue;
